var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "M98.7 81.697V65.953h-6.297v15.744c0 2.309-1.89 3.988-3.989 3.988H11.586c-2.31 0-3.989-1.889-3.989-3.988V65.953H1.3v15.744c0 5.668 4.618 10.286 10.286 10.286h76.828c5.668 0 10.286-4.618 10.286-10.286zM50 70.991l28.758-25.819-6.927-7.347-17.213 15.534.42-2.52V8.018H44.962V50.84l.42 2.519-17.213-15.534-6.927 7.347L50 70.992z"
  })));
};
export default SvgDownload;